import React from "react";

const SkeletonButton = ({ size = "md", width = "auto", className = "" }) => {
  const sizeClasses = {
    sm: "h-8",
    md: "h-10",
    lg: "h-12",
  };

  const widthClasses = {
    auto: "w-auto",
    full: "w-full",
    "1/4": "w-1/4",
    "1/3": "w-1/3",
    "1/2": "w-1/2",
  };

  return (
    <div
      className={`${sizeClasses[size]} ${widthClasses[width]} bg-gray-200 rounded animate-pulse ${className}`}
    />
  );
};

export default SkeletonButton;
